import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnAllowOnlySAForMaintenance,
} from '@product-framework/components/AuthorizationWrapper';
import CompanyEdit from './pages/edit/index';
import CompanyCreate from './pages/create/index';
import CompanyList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import CompanyFormStore from './store/index';

const Pages = ProtectedRoute => ({
  CompanyEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={CompanyEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  CompanyCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={CompanyCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  CompanyList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={CompanyList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { companyFormStore: new CompanyFormStore(rootStore) },
];

export { CompanyEdit, CompanyCreate, CompanyList, routes, stores };
